/* RESPONSIBLE TEAM: team-ai-agent */
import Model, { attr } from '@ember-data/model';
import { fragment } from 'ember-data-model-fragments/attributes';

export default class EscalationRule extends Model {
  @attr('string') declare appId: string;
  @attr('string') declare name: string;
  @attr('date') declare createdAt: Date;
  @fragment('predicates/predicate-group') declare predicateGroup: any;
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'ai-agent/escalation-rule': EscalationRule;
  }
}
